import React from 'react';

const SVG = ({
  style = {},
  fill = '#9192a4',
  width = '100%',
  className = '',
  viewBox = '0 0 25 25',
  title = 'Aggregators',
}) => (
  <svg
    fill={fill}
    width={width}
    style={style}
    className={`svg ${className}`}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <style>
        {`
          .svg-aggregators-1 { fill: none; }
          .svg-fill-aggregators { fill: ${fill}; }
        `}
      </style>
    </defs>
    <title>{title}</title>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Isolation_Mode" data-name="Isolation Mode">
        <path
          className="svg-fill-aggregators"
          d="M18.5,8.5l-.95,1L20,11.8H13.11c-1.7,0-2.95-1.9-3.25-3.34a2.4,2.4,0,1,0-1.42,0c.3,2,2,4.73,4.67,4.73H20l-2.46,2.28.95,1,4.31-4ZM10.13,6.18a1,1,0,1,1-1-1A1,1,0,0,1,10.13,6.18Z"
        />
        <path
          className="svg-fill-aggregators"
          d="M10.69,12.67a6.28,6.28,0,0,0-2.24,3.85,2.42,2.42,0,0,0-1.72,2.3,2.4,2.4,0,1,0,3.13-2.28,4.92,4.92,0,0,1,1.68-2.77l.19-.15-.85-1.1Zm-.56,6.15a1,1,0,1,1-1-1A1,1,0,0,1,10.13,18.82Z"
        />
        <path
          className="svg-fill-aggregators"
          d="M9.69,13.2V11.8H6.87a2.39,2.39,0,1,0,0,1.4Zm-4.11-.7a1,1,0,1,1-1-1A1,1,0,0,1,5.58,12.5Z"
        />
        <rect
          id="Rectangle_758"
          data-name="Rectangle 758"
          className="svg-aggregators-1"
          width="25"
          height="25"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
